export const toNumberIfNotEmptyString = value => (value !== '' ? Number(value) : value);
export const toDecimalNoRound = number => number && Number(number.toString().match(/^-?\d+(\.\d{0,2})?/)[0]);
